/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PlatformType {
    Web = 'Web',
    Spa = 'SPA'
}


export function instanceOfPlatformType(value: any): boolean {
    for (const key in PlatformType) {
        if (Object.prototype.hasOwnProperty.call(PlatformType, key)) {
            if (PlatformType[key as keyof typeof PlatformType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PlatformTypeFromJSON(json: any): PlatformType {
    return PlatformTypeFromJSONTyped(json, false);
}

export function PlatformTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformType {
    return json as PlatformType;
}

export function PlatformTypeToJSON(value?: PlatformType | null): any {
    return value as any;
}

export function PlatformTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PlatformType {
    return value as PlatformType;
}

